<template>
  <b-row class="mb-5">
    <b-col cols="12" class="mt-3">
      <b-card header-class="custom-header-bg">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left mt-1">
            <span class="mb-0 h3 ml-2">編輯商品</span>
          </div>
          <b-button variant="warning" class="border float-right" to="/admin/product">取消</b-button>
        </template>
        <b-row>
          <b-col md="6" offset-md="3">
            <b-form @submit.prevent="onSubmit" @reset="onReset">
              <b-tabs content-class="mt-3 mb-3" justified class="mt-3" lazy>
                <b-tab title="First" active ref="tab1">
                  <template slot="title">
                    <h4 class="mb-0 pt-1">1.編輯商品資訊</h4>
                  </template>
                  <b-form-group id="name-input-group" label-for="name-input">
                    <template slot="label">
                      <span class="text-danger">*</span> 商品名稱
                    </template>
                    <b-form-input id="name-input" v-model="name" required placeholder="校徽窗花 硬殼筆記本"></b-form-input>
                  </b-form-group>
                  <b-form-group id="img-file-group" label-for="img-file">
                    <template slot="label">
                      <span class="text-danger">*</span> 上傳商品圖片
                    </template>
                    <vue-draggable v-model="computedPics" tag="b-row" handle=".drag-handle">
                      <b-col md="4" cols="6" class="mt-3" v-for="(img, idx) in computedPics" :key="img.id">
                        <b-card header-class="text-center drag-handle" footer-class="p-0" body-class="p-0">
                          <template v-slot:header>
                            <h6 class="mb-0">
                              <font-awesome-icon icon="grip-vertical" class="mr-2"/>
                              ({{idx + 1}})
                              <span v-if="idx === 0" class="text-primary">主要圖片</span>
                              <span v-else>次要圖片</span>
                            </h6>
                          </template>
                          <b-card-img :src="img.link" @click="onClickEditImg(img)" class="custom-cursor"></b-card-img>
                          <template v-slot:footer>
                            <b-button-group class="w-100">
                              <b-button variant="primary" @click="onClickChangeImage(img)">
                                <font-awesome-icon icon="image" size="lg"/>
                              </b-button>
                              <b-button variant="danger" @click="$set(img, 'isDestroyed', true)">
                                <font-awesome-icon icon="times" size="lg"/>
                              </b-button>
                            </b-button-group>
                          </template>
                        </b-card>
                      </b-col>
                    </vue-draggable>
                    <b-form-file id="img-file-uploader" placeholder="上傳圖片" drop-placeholder="圖片拖曳至此上傳..." :disabled="fileUploading" @change="onImageFileUpload" :key="fileUploadKey" accept=".jpg,.jpeg,.png"></b-form-file>
                    <b-alert :show="UploadFileTooLargeAlert" dismissible fade variant="warning" class="mt-1">圖片超過限定大小</b-alert>
                    <b-alert :show="UploadFileReachMaxLimit" dismissible fade variant="warning" class="mt-1">上傳的圖片達到上限({{picMaxLimit}})</b-alert>
                    <ol style="font-size: 0.9rem" class="pt-2">
                      <li><mark>只支援jpg/jpeg/png格式，圖片大小不得超過2MB，最多6張</mark></li>
                      <li><mark>主要圖片為商品預覽圖</mark></li>
                      <li><mark>拖動上方區塊進行順序調整</mark></li>
                      <li><mark>點選圖片進行裁切</mark></li>
                      <li><mark>圖示寬高比例建議為1:1</mark></li>
                    </ol>
                  </b-form-group>
                  <b-form-group id="serial-input-group" label-for="serial-input">
                    <template slot="label">
                      <span class="text-danger">*</span> 商品編號
                    </template>
                    <b-form-input id="serial-input" v-model="serial" required></b-form-input>
                  </b-form-group>
                  <b-row>
                    <b-col cols="6">
                      <b-form-group id="price-input-group" label-for="price-input">
                        <template slot="label">
                          <span class="text-danger">*</span> 商品優惠價
                        </template>
                        <b-form-input id="price-input" v-model="price" required type="number" min="0"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group id="ori-input-group" label="商品單價" label-for="ori-input">
                        <b-form-input id="ori-input" v-model="ori" type="number" min="0"></b-form-input>
                      </b-form-group>
                    </b-col>
					<b-col cols="12">
                      <label id="descript-textarea-group" for="descript-textarea">商品簡述(最多約100字)</label>
                      <b-form-textarea id="descript-textarea" v-model="descript" placeholder="耐用的筆記本" class="w-100" rows="4" max-rows="8"></b-form-textarea>
					</b-col>
                  </b-row>
                  <b-button class="float-right mt-3" variant="info" type="submit">Next</b-button>
                </b-tab>
                <b-tab title="Second" ref="tab2">
                  <template slot="title">
                    <h4 class="mb-0 pt-1">2.編輯商品屬性</h4>
                  </template>
                  <b-row>
                    <b-col cols="6">
                      <b-form-group id="topClassify-selector-group" label-for="topClassify-selector">
                        <template slot="label">
                          <span class="text-danger">*</span>商品主分類
                        </template>
                        <b-form-select id="topClassify-selector" v-model="topClassify" required :options="topClassifyOptions"></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group id="subClassify-selector-group" label="商品子分類" label-for="subClassify-selector">
                        <b-form-select id="subClassify-selector" v-model="subClassify" :options="subClassifyOptions" :disabled="!Boolean(subClassifyOptions.length)"></b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-form-group id="size-input-group">
                    <template slot="label">
                      <span class="text-danger">*</span>商品規格與庫存數量
                    </template>
                    <b-row>
                      <!--b-col cols="6">
                        <b-form-input id="size-name-input" v-model="editSize.name" required></b-form-input>
                      </b-col>
                      <b-col cols="6">
                        <b-form-input id="size-amount-input" v-model="editSize.amount" required type="number" min="0"></b-form-input>
                      </b-col-->
                      <b-col cols="12">
                        <b-table bordered :items="size" :fields="SizeFields" head-variant="light" class="mt-2" small>
                          <template v-slot:cell(name)="row">
                            <b-form-input v-model="row.item.name" required/>
                          </template>
                          <template v-slot:cell(amount)="row">
                            <b-form-input v-model="row.item.amount" type="number" min="0" required/>
                          </template>
                          <template v-slot:head(ops)>
                            <span style="line-height: 31px;">操作</span><b-button variant="primary" class="float-right" size="sm" @click="onClickAddSize">新增</b-button>
                          </template>
                          <template v-slot:cell(ops)="row">
                            <b-button class="mt-1" variant="danger" size="sm" @click="onClickDeleteSize(row.item.id)">刪除</b-button>
                          </template>
                        </b-table>
                      </b-col>
                    </b-row>
                  </b-form-group>
                  <b-row>
                    <b-col cols="6">
                      <b-form-group id="publish-date-group" label-for="publish-date">
                        <template slot="label">
                          <span class="text-danger">*</span>上架日期
                        </template>
                        <b-form-datepicker id="publish-date" v-model="publishDate" class="mb-2" v-bind="DatepickerLabels('zh-tw')" value-as-date reset-button close-button></b-form-datepicker>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group id="discontinue-date-group" label="下架日期" label-for="discontinue-date">
                        <b-form-datepicker id="discontinue-date" v-model="discontinueDate" class="mb-2" v-bind="DatepickerLabels('zh-tw')" value-as-date reset-button close-button>></b-form-datepicker>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-form-group id="feature-editor-group" label="商品特色描述" label-for="feature-editor" class="ck-editor">
                    <ckeditor :editor="ClassicEditor" v-model="featureHtml" :config="editorConfig"></ckeditor>
                  </b-form-group>
                  <b-form-group id="format-editor-group" label="商品規格描述" label-for="format-editor" class="ck-editor">
                    <ckeditor :editor="ClassicEditor" v-model="formatHtml" :config="editorConfig"></ckeditor>
                  </b-form-group>
                  <b-form-group id="note-editor-group" label="購買須知描述" label-for="note-editor" class="ck-editor">
                    <ckeditor :editor="ClassicEditor" v-model="noteHtml" :config="editorConfig"></ckeditor>
                  </b-form-group>
                  <b-button class="ml-2 float-right" type="submit" variant="primary" :disabled="isBusy">確認送出</b-button>
                  <b-button class="mr-2 float-right" @click="$refs.tab1.activate()">上一步，編輯商品資訊</b-button>
                </b-tab>
              </b-tabs>
            </b-form>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-modal id="img-edit-modal" title="圖片裁切" cancel-title="取消" ok-title="儲存" size="lg" no-close-on-backdrop @shown="loadImgToCropper" @ok="onClickToSaveImg" @hide="onHideModal" @hidden="onResetModal">
      <mark>*圖示寬高比例建議為1:1</mark>
      <div class="w-100" ref="cropperContainer">
        <vue-cropper v-if="selectedImg" ref="cropper" :img="selectedImg.link" autoCrop fixed centerBox></vue-cropper>
      </div>
    </b-modal>
  </b-row>
</template>
<script>
import VueDraggable from 'vuedraggable'
import { VueCropper } from 'vue-cropper'
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
// Import translations
import '@ckeditor/ckeditor5-build-classic/build/translations/zh'
import { ApiPrefix, DatepickerLabels } from '../../library/Var.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faGripVertical,
  faImage,
  faTimes
} from '@fortawesome/free-solid-svg-icons'
library.add(faGripVertical, faImage, faTimes)
const UploadFileSizeLimit = 2 * 1024 * 1024 // 1MB = 1024^2 byte 
const MaxUploadLimit = 6
export default {
  name: 'admin-product-edit',
  components: {
    ckeditor: CKEditor.component,
    VueDraggable,
    VueCropper
  },
  data () {
    return {
      name: '',
      pics: [],
      serial: '',
      price: 0,
      ori: 0,
      descript: '',
      topClassify: null,
      subClassify: null,
      topClassifyOptions: [],
      subClassifyOptions: [],
      size: [],
      publishDate: new Date(),
      discontinueDate: null,
      featureHtml: '',
      formatHtml: '',
      noteHtml: '',
      UploadFileTooLargeAlert: 0,
      UploadFileReachMaxLimit: 0,
      fileUploadKey: Date.now(),
      fileUploading: false,
      isBusy: false,
      isTemp: false,
      selectedImg: null
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    ClassicEditor () {
      return ClassicEditor
    },
    editorConfig () {
      return {
        language: 'zh',
        ckfinder: {
          uploadUrl: `${ApiPrefix}/catalog/editor/img/upload/${this.id}`,
          options: {
            resourceType: "Images"
          }
        }
      }
    },
    SizeFields () {
      return [
        { key: 'name', label: '規格' },
        { key: 'amount', label: '庫存數量' },
        { key: 'ops', label: '操作', tdClass: 'text-center' }
      ]
    },
    computedPics: {
      get () {
        return this.pics.filter(item => !item.isDestroyed)
      },
      set (val) {
        this.pics = val
      }
    },
    picMaxLimit () {
      return MaxUploadLimit
    }
  },
  methods: {
    async init () {
      const { data: list } = await this.$api.getClassifyMain()
      list.sort((a, b) => a.sort - b.sort)
      this.topClassifyOptions = list.map(data => {
        const { id, name } = data
        return { id, text: name, value: id }
      })
    },
    async fetch () {
      const { data } = await this.$api.getProd(this.id)
      const {
        name = '', serial_number: serial, description = '',
        size = [], pics = [], isTemp, top = null, ori_price = 0, price = 0,
        sub = null, start = null, end = null, raw_feature_html = '',
        raw_specification_html = '', raw_notice_html = ''
      } = data
      this.name = name
      this.serial = serial
      this.size = size
      pics.sort((a, b) => a.sort - b.sort)
      this.pics = pics.map(item => {
        const { id } = item
        return {
          id,
          link: this.$api.catalogImageLink(this.id, id)
        }
      })
      // inject other data
      this.topClassify = top? top.id : null
      this.subClassify = sub ? sub.id : null
      this.descript = description
      this.price = price
      this.ori = ori_price
      this.publishDate = start ? new Date(start) : new Date()
      this.discontinueDate = end ? new Date(end) : null
      this.featureHtml = raw_feature_html
      this.formatHtml = raw_specification_html
      this.noteHtml = raw_notice_html
      this.isTemp = isTemp
    },
    async onSubmit () {
      // if not in tab 2
      if (this.computedPics.length === 0) {
        this.showToast('fail', '請添加至少一張商品圖示')
        return
      }
      if (this.$refs.tab2.activate()) {
        this.$scrollTop()
        return
      }
      if (this.size.length === 0) {
        this.showToast('fail', '請添加至少一種商品規格及其數量')
        this.$scrollTop()
        return
      }
      this.isBusy = true
      const data = {
        classify: this.subClassify || this.topClassify,
        serial_number: this.serial,
        name: this.name,
        pics: this.computedPics.map(p => p.id),
        ori_price: this.ori,
        price: this.price,
        description: this.descript,
        start: this.publishDate.valueOf(),
        end: this.discontinueDate? this.discontinueDate.valueOf() : null,
        raw_feature_html: this.featureHtml,
        raw_specification_html: this.formatHtml,
        raw_notice_html: this.noteHtml,
        size: this.size.map(item => {
          const { id, name, amount } = item;
          return { id, name, amount }
        })
      }
      try {
        await this.$api.putProd(data, this.id)
        this.showToast()
        this.$router.push('/admin/product')
      } catch (err) {
        console.log(err)
        this.showToast('failed')
      }
      this.isBusy = false
    },
    onReset () {
      this.init()
      this.fetch()
    },
    onClickAddSize () {
      this.size.push({id: Date.now(), name: '', amount: 0})
    },
    onClickDeleteSize (id) {
      this.size = this.size.filter(item => item.id !== id)
    },
    async onImageFileUpload ({ target: $dom }) {
      this.fileUploading = true
      const { files: [ fileData ] } = $dom
      if (!fileData) return
      const size = fileData.size
      let findImg = this.pics.find(item => item.markChange)
      if (size > UploadFileSizeLimit) {
        // pic size too large
        this.UploadFileTooLargeAlert = 5 
      } else if (!findImg && this.pics.length >= MaxUploadLimit) {
        // is new pic and reach max limit
        this.UploadFileReachMaxLimit = 5
      } else {
        // upload
        try {
          const formData = new FormData()
          formData.append('file', fileData)
          const { data: { id } } = await this.$api.putImg(formData, this.id)
          // find pics is mark change
          const link = this.$api.catalogImageLink(this.id, id)
          if (findImg) {
            // change event
            this.$set(findImg, 'id', id)
            this.$set(findImg, 'link', link)
            this.$set(findImg, 'markChange', false)
          } else {
            // add new item
            findImg = { id, link }
            this.pics.push(findImg)
          }
          // detect img width and height
          const img = new Image()
          // load event callback
          const self = this
          img.onload = function () {
            // if not equal between width and height, call cropper
            if (this.width !== this.height) {
              self.onClickEditImg(findImg)
            }
          }
          img.src = link
        } catch (err) {
          console.log(err)
        }
      }
      // change key will refresh dom object
      this.fileUploadKey = Date.now()
      this.fileUploading = false
    },
    onClickChangeImage (img) {
      this.$set(img, 'markChange', true)
      document.getElementById('img-file-uploader').click()
    },
    DatepickerLabels,
    showToast (failed, msg) {
      let variant, title, message;
      if (failed) {
        message = msg || '更新發生錯誤，請重新嘗試'
        variant = 'danger'
        title = '操作失敗'
      } else {
        message = msg || '資料已更新'
        variant = 'success'
        title = '操作成功'
      }
      this.$bvToast.toast(message, { variant, title })
    },
    onClickEditImg (img) {
      const { link } = img
      if (link) {
        this.$bvModal.show('img-edit-modal')
        this.selectedImg = img
      }
    },
    loadImgToCropper () {
      const container = this.$refs.cropperContainer
      const { clientWidth } = container
      container.style.height = `${clientWidth}px`
      this.$refs.cropper.startCrop()
    },
    onClickToSaveImg (bvModalEvt) {
      // disable auto hide
      bvModalEvt.preventDefault()
      // get blob data from cropper
      this.$refs.cropper.getCropBlob(async blob => {
        // upload and replace to original pic
        try {
          const formData = new FormData()
          formData.append('file', blob)
          const { data: { id } } = await this.$api.putImg(formData, this.id)
          // find pics is mark change
          const findImg = this.selectedImg
          const link = this.$api.catalogImageLink(this.id, id)
          this.$set(findImg, 'id', id)
          this.$set(findImg, 'link', link)
          this.$set(findImg, 'markChange', false)
        } catch (err) {
          console.log(err)
        }
        // all done, close modal
        this.onResetModal()
      })
    },
    onHideModal () {
      // hide event always call even preventDefault
      this.$refs.cropper.stopCrop()
    },
    onResetModal () {
      this.selectedImg = null
      this.$bvModal.hide('img-edit-modal')
    }
  },
  mounted () {
    this.init()
    this.fetch()
  },
  watch: {
    async topClassify (id) {
      let list = []
      if (id) {
        const { data } = await this.$api.getClassifySub(id)
        data.sort((a, b) => a.sort - b.sort)
        list = data.map(data => {
          const { id, name } = data
          return { id, text: name, value: id }
        })
      }
      list.unshift({ id: Date.now(), text: '-----不分類-----', value: null })
      this.subClassifyOptions = list
    }
  }
}
</script>
<style scoped>
  .ck-editor /deep/ .ck-editor__editable {
    min-height: 500px;
  }
  .drag-handle {
    cursor: grab
  }
  .custom-cursor {
    cursor: pointer;
  }
</style>